<template>
     <div class="my-info">
    <div class="content">
      <!-- 基本信息部分 -->
      <div class="info-section">
        <div class="section-title" style="display: flex;align-items: center;">
            <span> 个人资料</span>
            <van-button type="primary" size="mini" @click="updateUser()">点击修改</van-button>
        </div>
        <van-cell-group inset>
            <van-cell title="头像" center >
            <template #value>
              <van-uploader
              round
                :max-count="1"
                :after-read="afterRead"
              >
                <div class="avatar-wrapper">
                  <img v-if="userInfo.avatar" :src="userInfo.avatar" class="avatar" />
                  <!-- <van-icon v-else name="photograph" size="48" /> -->
                </div>
              </van-uploader>
            </template>
          </van-cell>
          <van-cell title="昵称" :value="userInfo.nickname?userInfo.nickname:userInfo.username" />
          <van-cell v-if="userInfo.isVip==0">
            <template #title>
                <div style="display: flex;justify-content: space-between;">
                    <span>商家VIP会员</span>
                    <van-tag  v-if="userInfo.isVip==0 && !userInfo.vipExpireDate"
                     type="warning" style="margin-left: 8px;text-align: right;">VIP会员(已过期)</van-tag>
                     <van-tag  v-else
                     type="danger" style="margin-left: 8px;text-align: right;">VIP会员</van-tag>
                </div>
              
            </template>
          </van-cell>
          <van-cell  v-if="userInfo.isVip==0" title="商家等级" :value="userInfo.level" />
          <van-cell  v-if="userInfo.isVip==0" title="商家成长值" :value="userInfo.growthValue" />
          <van-cell  v-if="userInfo.isVip==0" title="商家号" :value="userInfo.merchantId" />
          <van-cell title="邀请码" :value="userInfo.inviteCode"  />
          <van-cell>
            <template #title>
                <div style="display: flex;justify-content: space-between;">
                    <span>实名认证</span>
                    <van-tag type="success" style="margin-left: 8px;" v-if="userInfo.verifyFlag == 1 ">已认证</van-tag>
                    <span v-else style="margin-left: 8px;color: #1989fa;font-weight: bold;">立即认证</span>
                </div>
            
            </template>
          </van-cell>
          <van-cell title="手机号" :value="userInfo.phone" />
          <van-cell title="微信号" :value="userInfo.weiChat" />
          <van-cell title="QQ号" :value="userInfo.qqNum" />
          <van-cell title="邮箱" :value="userInfo.email" />
        </van-cell-group>
      </div>

      <!-- 账号安全部分 -->
      <!-- <div class="info-section">
        <div class="section-title" style="display: flex;align-items: center;">
            <span> 账号安全</span>
            <van-button type="primary" size="mini" @click="updateUser()">点击修改</van-button>
        </div>

        <van-cell-group inset>
          
        </van-cell-group>
      </div> -->
    </div>

    <van-popup v-model:show="showEditPopup" position="center" round height="40%">
    <div class="edit-form">
      <div class="popup-title">修改信息</div>
      <van-form @submit="onSubmit">
        <van-field
          v-model="editForm.username"
          label="昵称"
          placeholder="请输入昵称"
        />
        <van-field
          v-model="editForm.phone"
          label="手机号"
          placeholder="请输入手机号"
        />
        <van-field
          v-model="editForm.weiChat"
          label="微信号"
          placeholder="请输入微信号"
        />
        <van-field
          v-model="editForm.qqNum"
          label="QQ号"
          placeholder="请输入QQ号"
        />
        <van-field
          v-model="editForm.email"
          label="邮箱"
          placeholder="请输入邮箱"
        />
        <div class="form-buttons">
          <van-button plain type="default" block @click="showEditPopup = false">取消</van-button>
          <van-button type="primary" block native-type="submit">确定</van-button>
        </div>
      </van-form>
    </div>
  </van-popup>
  </div>
</template>

<script>
import request from '@/utils/request'
import {showToast} from 'vant'
export default {
    name: 'MyInfo',
    data() {
        return {
            userInfo: {},
            showEditPopup: false,
            editForm: {
            },
            fileList: [], // 添加文件列表数据
        }
    },
    created() {
        this.userInfo = this.$store.state.user.userInfo
        if (this.userInfo.avatar) {
            // this.fileList = [{ url: this.userInfo.avatar }]
        }
  },
    methods: {
      async  afterRead(raw) {
      // 这里可以调用上传 API
      console.log('上传文件：', raw.file)
      await this.updateInfo(raw.file)
    },
   async updateInfo(file=null) {
        let res = ''
        let fileUrl = ''
        let data = {}
        if(file != null){
            let formData = new FormData()
            formData.append('file',file)
            res = await request.post('/common/other/upload', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
            })
            if(res.code == 200){
                console.log(111)
                fileUrl = res.url
                data.avatar = fileUrl
            }
        }
        console.log(222)
       
       if(this.editForm.username){
              data.userName= this.editForm.username
              data.weiChat= this.editForm.weiChat
              data.qqNum= this.editForm.qqNum
              data.email= this.editForm.email
       }
        request.post('/front/profile/updateUserInfo',data).then(res2=>{
              if(res2.code == 200){
                
                this.$store.dispatch('user/getUserInfo').then(res => {
                  if(res.code == 200){
                  this.userInfo = res.data
                  showToast({
                    message: '更新成功',
                    type: 'success'
                    })
                    this.showEditPopup = false
                }
                })
              }
            })
           
     
    },
        updateUser() {
        this.showEditPopup = true
        // 修正字段名称
        this.editForm = Object.assign({}, this.userInfo)
    },
        onSubmit() {
            // 这里添加保存逻辑
            console.log('保存修改：', this.editForm)
            // 更新userInfo
            Object.assign(this.userInfo, this.editForm)
            // let formData = new FormData()
            this.updateInfo()
    //   formData.append('file',file.raw)
    //   request.post('/common/upload', formData, {
    //       headers: {
    //         'Content-Type': 'multipart/form-data'
    //       }
    //     }).then(res => {
    //       if(res.code == 200){
    //         let avatarFileUrl =  res.url
    //         request.post('/front/profile/updateUserInfo',{
    //           avatar:avatarFileUrl
    //         }).then(res2=>{
    //           if(res2.code == 200){
    //             // this.$message.success('头像更新成功')
    //             this.$store.dispatch('user/getUserInfo').then(res => {
    //               if(res.code == 200){
    //               this.userinfo = res.data
    //             }
    //             })
    //           }
    //         })
        
    //       }
    //     })
        }
    }
}
</script>

<style  scoped>
.my-info {
  min-height: 100vh;
  background-color: #f5f5f5;

}
 

  ::v-deep .van-cell {
    align-items: center;

    
  }
  .van-cell__title {
      flex: 0 0 80px;
      color: #666;
    }

    .van-cell__value {
      color: #333;
      text-align: left;
    }

  .info-section {
    margin: 16px 0;

   
  }
  .section-title {
      padding: 0 16px;
      margin-bottom: 12px;
      font-size: 16px;
      font-weight: 500;
      color: #323233;
      font-weight: bold;
    }

.edit-form {
    padding: 20px;
    width: 320px;
}
.popup-title {
    text-align: center;
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 20px;
  }

  .form-buttons {
    margin-top: 20px;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px;
  }

  .van-field {
    margin-bottom: 12px;
  }

  .my-info {
  min-height: 100vh;
  background-color: #f5f5f5;
}

.avatar-wrapper {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f2f3f5;
}

.avatar {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

</style>